import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalRef, ModalService } from '@common/services/modal.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnDestroy {

  @Input()
  public loader: () => Observable<boolean>;

  @Input()
  public closable: boolean = true;

  @Input()
  public lock: boolean = false;

  private _loading: boolean = true;
  private _error: boolean = false;
  private _height: number = 100;
  private _timeout = null;

  private element: HTMLElement = this.elementRef.nativeElement as HTMLElement;

  public get loading(): boolean {
    return this._loading;
  }

  public get error(): boolean {
    return this._error;
  }

  constructor(private elementRef: ElementRef, private modal: ModalService) {
  }  

  public hide() {
    this.modal.hide();
  }

  public reload() {

    if (this.loader) {

      this._loading = true;
      this.modal.closable(false);
      this.animation(false);

      this.loader().subscribe(succeed => {

        this._error = !succeed;
        this._loading = false;
        this.modal.closable(true);
        this.animation(true);
      });
    }
    else {
      this._error = false;
      this._loading = false;
      this.modal.closable(true);
      this.animation(true);
    }
  }

  ngOnInit() {
    this.reload();
  }

  ngOnDestroy() {
    this.cleanup();
  }

  private cleanup() {
    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = null;
    }
  }

  private animation(enabled: boolean) {

    this.cleanup();
    this.element.style.setProperty('height', this._height + "px");

    if (!enabled) {
      this.element.classList.add('show-content');
    }
    else {
      this.element.classList.remove('show-content');
      setTimeout(() => this.fitContent(), 0);
    }
  }

  private fitContent(ref?: any) {

    if (ref && ref != this._timeout) return;

    let y: { min: number, max: number };

    for (let i = 0; i < this.element.children.length; i++) {
      let rect = this.element.children[i].getBoundingClientRect() as DOMRect;
      y = y ? { min: Math.min(y.min, rect.y), max: Math.max(y.max, rect.y + rect.height) } : { min: rect.y, max: rect.y + rect.height };
    }

    if (!y) {
      this._timeout = ref = setTimeout(() => this.fitContent(ref), 16);
      return;
    }

    let required = Math.min(Math.round(y.max - y.min), window.innerHeight);

    if (this._height != required) {
      this.element.classList.remove('show-content');
      this._height += Math.round(this._height < required ? Math.max((required - this._height) / 2, 1) : Math.min((required - this._height) / 2, -1));
      this.element.style.setProperty('height', this._height + "px");

      this._timeout = ref = setTimeout(() => this.fitContent(ref), 16);
    }
    else {
      this.element.classList.add('show-content');
      this.element.style.removeProperty('height');
    }
  }  
}
